"use strict";
/**
 * DropDownComponent
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var material_1 = require("@mui/material");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var TooltipComponent_1 = __importDefault(require("../MessageComponents/TooltipComponent"));
var LabelWithTooltipComponent_1 = __importDefault(require("../MessageComponents/LabelWithTooltipComponent"));
var Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
var DeleteForever_1 = __importDefault(require("@mui/icons-material/DeleteForever"));
var Backspace_1 = __importDefault(require("@mui/icons-material/Backspace"));
var Clear_1 = __importDefault(require("@mui/icons-material/Clear"));
var HighlightOff_1 = __importDefault(require("@mui/icons-material/HighlightOff"));
var DropDownComponent = function (props) {
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var theme = react_redux_1.useSelector(crude_selector_1.getTheme);
    var _a = react_1.useState(null), value = _a[0], setValue = _a[1];
    var _b = react_1.useState([]), options = _b[0], setOptions = _b[1];
    var StyledPopper = function (props) {
        return (react_1.default.createElement(material_1.Popper, __assign({}, props, { disablePortal: false, style: {
                width: props.anchorEl.clientWidth,
                border: "2px solid " + theme.palette.primary.main,
                borderRadius: '4px',
                inset: '5px auto auto 0px !important',
                '& .MuiAutocomplete-option:hover': {
                    color: theme.palette.primary.main,
                },
                '& .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                    backgroundColor: theme.palette.grey.A100,
                },
                '& .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected="true"]': {
                    backgroundColor: 'transparent',
                },
            }, placement: 'bottom-end' })));
    };
    react_1.useEffect(function () {
        props.value ? setValue(props.value) : setValue(null);
    }, [props.value]);
    react_1.useEffect(function () {
        props.options && setOptions(props.options);
    }, [props.options]);
    var getClearIcon = function () {
        var _a, _b, _c, _d, _e;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            ((_a = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _a === void 0 ? void 0 : _a.deleteIcon) === 'delete' &&
                react_1.default.createElement(Delete_1.default, null),
            ((_b = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _b === void 0 ? void 0 : _b.deleteIcon) === 'deleteForever' &&
                react_1.default.createElement(DeleteForever_1.default, null),
            ((_c = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _c === void 0 ? void 0 : _c.deleteIcon) === 'backspace' &&
                react_1.default.createElement(Backspace_1.default, null),
            ((_d = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _d === void 0 ? void 0 : _d.deleteIcon) === 'clear' &&
                react_1.default.createElement(Clear_1.default, null),
            ((_e = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _e === void 0 ? void 0 : _e.deleteIcon) === 'highlightOff' &&
                react_1.default.createElement(HighlightOff_1.default, null)));
    };
    return (react_1.default.createElement(material_1.Autocomplete, { options: options, value: value, clearIcon: getClearIcon(), size: props.size, disableClearable: props.disableClearable, limitTags: props.limitTags, defaultValue: props.defaultValue, isOptionEqualToValue: function (option, value) { return option.key === value.key; }, getOptionLabel: function (option) { return option.value; }, renderOption: function (props, option) {
            var element = react_1.default.createElement("span", null, option.value);
            return (react_1.default.createElement(material_1.Box, __assign({ component: 'li' }, props), option.description
                ? (react_1.default.createElement(TooltipComponent_1.default, { title: option.description, placement: 'right', element: element }))
                : react_1.default.createElement(react_1.default.Fragment, null, element)));
        }, PopperComponent: StyledPopper, onChange: function (event, newValue) {
            setValue(newValue);
            props.onChange && props.onChange(newValue);
        }, renderInput: function (params) {
            var _a;
            return (react_1.default.createElement(material_1.TextField, __assign({}, params, { required: props.disableClearable, InputLabelProps: {
                    shrink: true,
                    style: { pointerEvents: 'auto', display: 'flex', alignItems: 'center' },
                }, label: props.label &&
                    react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: props.label, description: props.description }), name: props.name, color: props.color, sx: {
                    width: props.width ? props.width : props.fullWidth ? '100%' : '300px',
                    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main,
                        borderWidth: 2,
                    },
                }, placeholder: props.placeholder, variant: (_a = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _a === void 0 ? void 0 : _a.type })));
        }, disabled: props.disabled ? props.disabled : false }));
};
exports.default = DropDownComponent;
